import { Card } from 'antd';
import React from 'react';

const ComingSoon = () => {
    return (
        <Card bodyStyle={{ textAlign: "center" }} style={{ padding: 30 }}>
            <div style={{ padding: 30 }}>
                <h1>Coming Soon</h1>
            </div>
        </Card>
    );
}

export default ComingSoon;